import getDevice from './module/getDevice.js'
import getBaseUrl from './module/getBaseUrl.js'
import functions from './functions.js'

const baseUrl = getBaseUrl()
// console.log('URL base detectada:', baseUrl)

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////// DEVICE DATA ///////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

/**
 * Objeto único de datos de dispositivo. Los módulos guardan esta MISMA
 * referencia, así que refrescarlo con Object.assign los mantiene al día.
 * Antes el listener de resize descartaba el resultado de getDevice(), con lo
 * que los módulos seguían usando el `isDesktop` de la carga inicial.
 */
const deviceData = getDevice()

let resizeTimer = null

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo.
   getDevice() lee offsetHeight/scrollHeight (fuerza reflow), por eso se
   agrupa en lugar de correr en cada evento de resize. */
const refreshDeviceData = () => {
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => {
    Object.assign(deviceData, getDevice())
  }, 150)
}

window.addEventListener('resize', refreshDeviceData, { passive: true })
window.addEventListener('orientationchange', refreshDeviceData, { passive: true })

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////////// EXEC //////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
})
